import { controllerCalenderTypes } from './const-data';

const getUserProfileImagePath = (last_name) => {
    // Check if the user or user's last_name exists
    const firstLetter = last_name?.charAt(0)?.toUpperCase();

    if (firstLetter) {
        try {
            // Dynamically require the image based on the first letter
            return require(`../images/profile-tamp/${firstLetter}.png`);
        } catch (error) {
            // If the specific image doesn't exist, fallback to the common image
            return require('../images/profile-tamp/common.png');
        }
    } else {
        // If user or last_name is not defined, or the first letter could not be determined
        return require('../images/profile-tamp/common.png');
    }
}

const listCitiesFromArrayObj = (arr) => {
    let cities = [...new Set(arr.filter(item => item.address.city).map(item => item.address.city))];
    cities = cities.map(city => ({
        value: city,
        label: city
    }));

    return cities;
}

const listValuesFromArrayObj = (arr, keyPath) => {
    const values = [
        ...new Set(
            arr
                .filter(item => {
                    // Access nested or top-level key using reduce
                    return keyPath.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), item);
                })
                .map(item => {
                    // Extract value from nested or top-level key
                    return keyPath.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), item);
                })
        ),
    ];
    return values;
};

const calculatePercentage = (total = 0, percentage = 100) => {
    if (Number(total) && Number(percentage)) {
        return parseFloat((Number(percentage) / 100) * Number(total).toFixed(2))
    }
    throw Error('Pass the number')
}

const calculateTotalAmount = (list = [], discount = 0, gst = false) => {
    const listTotal = list.reduce((total, item) => total + (Number(item.rate) * Number(item?.qty)), 0);

    let totalAmount = 0
    if (gst) {
        totalAmount = listTotal + calculatePercentage(listTotal, 18)
    } else {
        totalAmount = listTotal - discount
    }

    return parseFloat(totalAmount).toFixed(2);
}

const calculateGSTAmount = (list = []) => {
    const listTotal = list.reduce((total, item) => total + (Number(item.rate) * Number(item?.qty)), 0);
    let gstAmount = calculatePercentage(listTotal, 18)

    return parseFloat(gstAmount).toFixed(2);
}

const findTdsStatus = (inValue = 0, outValue = 0, productCategory = 'RO') => {

    let productFilterType = 'RO'
    if (['UV', 'UV+UF'].includes(productCategory)) {
        productFilterType = 'UV'
    } else if (['RO+ALKALINE', 'RO+UV+ALKALINE', 'RO+UV+UF+ALKALINE'].includes(productCategory)) {
        productFilterType = 'ALKALINE'
    }

    if (typeof inValue !== 'number' || typeof outValue !== 'number') {
        throw Error('TDS inValue / outValue is not Number')
    }

    // NO
    if (!inValue || !outValue) {
        return 'No'
    }

    // LOW
    if (outValue < 5) {
        return 'Low'
    }

    // TYPE : UV
    if (productFilterType === 'UV') {
        if (outValue > (inValue + 50)) {
            return 'High'
        } else {
            return 'Normal'
        }
    }

    // TYPE : ALKALINE
    if (productFilterType === 'ALKALINE') {
        if (outValue > ((inValue * 0.15) + 40)) {
            return 'High'
        } else {
            return 'Normal'
        }
    }

    // TYPE : RO
    if (outValue > inValue * 0.15) {
        return 'High'
    } else {
        return 'Normal'
    }

}

const sizeOfJson = (dataPack) => {
    const jsonString = JSON.stringify(dataPack);
    const byteSize = new TextEncoder().encode(jsonString).length;

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let size = byteSize;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    return `${size.toFixed(1)} ${units[unitIndex]}`;
}

function getStatusDetails(statusId) {
    for (const app of controllerCalenderTypes) {
        const status = app.status_list.find(status => status.id === statusId);
        if (status) {
            return {
                appId: app.id,
                appName: app.name,
                statusId: status.id,
                statusName: status.name,
                colorCode: status.color_code
            };
        }
    }
    return null; // Return null if statusId is not found
}



export {
    getUserProfileImagePath, listCitiesFromArrayObj, calculatePercentage, calculateTotalAmount, calculateGSTAmount,
    findTdsStatus, sizeOfJson, getStatusDetails, listValuesFromArrayObj
}